import React, { useState, useEffect, useMemo } from 'react';
import { Dialog, Box, Tabs, Tab, DialogContent, styled } from '@mui/material';
import { filter, forEach, toLower, map, unionBy, includes, isEmpty } from 'lodash';

import { GROUPED_VIDEOS_LIST } from '../helpVideosList.js';
import VideoPlayerView from '../VideoPlayerView';
import BrandMark from '../../../elements/brand/BrandMark';
import Clock from './Clock.svg';

import './VideoTabs.scss';

const muiStyles = {
  dialogContent: {
    display: 'flex',
    padding: '0 !important',
    background: 'red',
  },
};
const StyledDialogContent = styled(DialogContent)(muiStyles.dialogContent);

export default function VideoTabs({ searchText }) {
  const DEFAULT_TAB = 'allvideosGroup';
  const [list, setList] = useState([]);
  const [currentTab, setCurrentTab] = useState(DEFAULT_TAB);
  const [currentVideo, setCurrentVideo] = useState({});

  const _currentTabList = useMemo(() => {
    return filter(list, (tab) => tab.index === currentTab).pop();
  }, [currentTab, list]);

  const handleChange = (event, tabIndex) => {
    setCurrentTab(tabIndex);
  };

  useEffect(() => {
    setCurrentTab(DEFAULT_TAB);
    const listTemp = _generateList();
    setList(listTemp);
  }, [searchText]);

  const _generateList = () => {
    const { groupOrder, groupRules, videoItems } = GROUPED_VIDEOS_LIST;
    let list = [];
    let allVideos = [];
    forEach(groupOrder, (currGroup) => {
      const thisGroup = groupRules[currGroup];
      // thisGroup.optionsOrder
      const thisGroupOptions = filter(thisGroup.optionsOrder, (op) => {
        if (!searchText || searchText === '') {
          return true;
        }
        const { displayName } = videoItems[op];
        return includes(toLower(displayName), toLower(searchText));
      }).map((op, idx) => {
        const thisVideo = videoItems[op];
        return {
          ...thisVideo,
        };
      });

      if (thisGroupOptions.length > 0) {
        list.push({
          ...thisGroup,
          videos: thisGroupOptions,
        });
      }
      //TODO: unionBy is too roundabout. Not a bad call given the list size and memo, but we can do better.
      allVideos = unionBy(allVideos, thisGroupOptions, 'index');
    });

    list.unshift({
      displayName: 'All Videos',
      index: DEFAULT_TAB,
      videos: allVideos,
    });
    return list;
  };

  const _handleVideoClick = (video) => {
    setCurrentVideo(video);
  };
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="Video Support"
          variant="scrollable"
        >
          {map(list, (tab, index) => (
            <Tab value={tab.index} label={tab.displayName} key={tab.index} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ width: '100%' }}>
        <div className="video-tabs tab-content">
          {_currentTabList &&
            map(_currentTabList.videos, (video) => (
              <div
                className="video-item"
                key={video.index}
                onClick={() => _handleVideoClick(video)}
              >
                <div className="thumbnail-container">
                  <img src="" src={video.thumbnail} />
                </div>
                <h2>{video.displayName}</h2>
                <span>
                  <img src={Clock} alt={''} />
                  {video.duration}
                </span>
              </div>
            ))}

          {(!_currentTabList || (_currentTabList && _currentTabList.videos.length === 0)) && (
            <div className="novideo-container">
              <div className="brandmark-container">
                <BrandMark animated={true} />
              </div>
              <div className="message-box">
                <h1>
                  Uh oh! No result for <span>{searchText}</span>
                </h1>
              </div>
            </div>
          )}
        </div>
      </Box>

      <Dialog
        open={!isEmpty(currentVideo)}
        onClose={() => {
          setCurrentVideo({});
        }}
        maxWidth={'lg'}
        fullWidth
      >
        <StyledDialogContent key={currentVideo.videoId}>
          <VideoPlayerView videoId={currentVideo.videoId} videoUrl={currentVideo.url} />
        </StyledDialogContent>
      </Dialog>
    </>
  );
}
